import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class filterTag_template extends vnTemplate {

    static SINGLE_SELECTION_MODE: string = 'single';
    static MULTIPLE_SELECTION_MODE: string = 'multiple';

    protected tagContainerId: string = 'selected-tags';
    protected tagContainerCaption: string = 'Selected Tags:';

    protected delay = 300;
    protected debounceTimerId: number;

    protected getTemplateHtml(): string {

        return /* html */`
                <div class="w-spec-search icon i-auto-complete" data-bind="class: iconClass">
                    <input
                        list="tags"
                        class="input-text"
                        style="padding-left: 3rem;"
                        data-bind="
                            disable: isGlobalLockEnabled() || isDisabled(),
                            textInput: tag,
                            event: { keyup: onChangeInput },
                            valueUpdate: 'afterkeydown',
                            attr: { id:idTag, placeholder: placeholderText },
                        "
                    >
                        <!-- ko if: optionsLoading -->
                        <span class="form-loading" ></span>
                        <!-- /ko -->
                        <ul class="form-auto-list" data-bind="foreach: tags, visible: isShowTagSuggestions" id="tags">
                            <li class="form-auto-item"
                                data-bind="
                                    css: {'is-active':($data.isSelectable == 1)},
                                    attr: { id:id },
                                    text: $data.name + ($parent.showType() ? ' ' + $data.formattedTagTypeAndDataset : ''),
                                    click: $parent.onBlurTag
                                "
                            ></li>
                        </ul>
                    </input>
                    <button data-bind="event: { click: onClearInput }, css: { 'is-showing': showXButton }" class="close-btn icon i-x-after" id="tag-input-close" type="button"><span class="hidden-text">close</span></button>
                </div>
                `;
    }

    protected getTemplateName(): string {
        return "filterTag-template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            placeholderText: ko.observable("Tag"),
            iconClass: ko.observable("i-tag-a"),
            selectionMode: ko.observable(filterTag_template.SINGLE_SELECTION_MODE),
            tags: ko.observableArray([]),
            idTag: ko.observable(null),
            tag_value: ko.observable(""),
            tag: ko.pureComputed({
                read: () => {
                    return self.getTemplateViewModel().tag_value();
                },
                write: (value) => {
                    self.getTemplateViewModel().showXButton(!!value);
                    self.getTemplateViewModel().tag_value(value);
                }
            }),
            tagObj: ko.observable(null),
            tagObjs: ko.observableArray([]),
            orderBy: "dateCreation",
            orderByDirection: "DESC",
            showXButton: ko.observable(false),
            showType: ko.observable(true),
            isShowTagSuggestions: ko.observable(false),
            isGlobalLockEnabled : ko.observable(false),
            isDisabled : ko.observable(false),
            optionsLoading: ko.observable(false),
            onChangeInput: (data, event): void => {
                self.onChangeInput(data, event);
            },
            onClearInput: (data, event): void => {
                self.onClearInput(event);
            },
            onChangeFilterAction: (data, event):void => {
                self.onChangeFilterAction(data)
            },
            onBlurTag: (data, event): void => {
                self.onBlurTag(data, event);
            }
        };
    }

    public setTagContainerId(tagContainerId: string): void {
        this.tagContainerId = tagContainerId;
    }

    public getTagContainerId(): string {
        return this.tagContainerId;
    }

    public getTagContainer()
    {
        return document.getElementById(this.tagContainerId);
    }


    public resetTagContainer(): void {
        if (this.getTagContainer()) {
            this.getTagContainer().innerHTML = '';
            this.setTagObjs([]);
        }
    }

    protected addCaption()
    {
        if (this.getTagContainer()) {
            if (!this.hasCaption()) {
                this.getTagContainer().appendChild(this.createCaption());
            }
        }
    }

    protected hasCaption(): boolean {

        let captions = this.getTagContainer().getElementsByTagName('label');

        return (captions.length > 0);

    }

    protected createCaption()
    {
        let element = document.createElement('label');

        element.setAttribute('class', 'small');
        element.appendChild(document.createTextNode(this.tagContainerCaption));

        return element;
    }

    protected addHtmlTag(tag)
    {
        if (this.getTagContainer()) {

            this.getTagContainer().appendChild(this.createHtmlTag(tag));
        }
    }

    protected createHtmlTag(tag)
    {
        let self = this;

        let element = document.createElement('button');

        element.setAttribute('id', tag.id);
        element.appendChild(document.createTextNode(tag.name));
        element.setAttribute('class', 'btn-f-s icon i-x-after');
        element.setAttribute('type', 'button');

        element.addEventListener('click', function (e) {

            // @ts-ignore
            self.removeTagFromSelection(e.target.getAttribute('id'));
            // @ts-ignore
            self.getTagContainer().removeChild(e.target);
            if (self.getTagObjs().length == 0) {
                self.resetTagContainer();
            }

            self.caller.filterSimpleOnChange(self.idElement);
        }, false);

        return element;
    }

    public setTagContainerCaption(tagContainerCaption: string): void {
        this.tagContainerCaption = tagContainerCaption;
    }

    public getTagContainerCaption(): string {
        return this.tagContainerCaption;
    }
    public setSelectionMode(selectionMode): void {
        this.getTemplateViewModel().selectionMode(selectionMode);
    }

    public getSelectionMode() {
        return this.getTemplateViewModel().selectionMode();
    }

    public setTags(tags): void {
        this.getTemplateViewModel().tags(tags);
        this.getTemplateViewModel().optionsLoading(false);
    }

    public getTags() {
        return this.getTemplateViewModel().tags();
    }

    public setIdTag(idTag): void {
        this.getTemplateViewModel().idTag(idTag);
    }

    public setTag(tag): void {
        let showType = this.getShowType();
        this.getTemplateViewModel().tag(`${tag.name} ${showType && (tag.type || tag.tagType)? tag.formattedTagTypeAndDataset : ''}`);
        this.setTagObj(tag);
        this.setIdTag(tag.id);
    }

    public setTagObj(tagObj): void {
        this.getTemplateViewModel().tagObj(tagObj);
    }

    public getTagObj() {
        return this.getTemplateViewModel().tagObj();
    }
    public setTagObjs(tagObjs): void {
        this.getTemplateViewModel().tagObjs(tagObjs);
    }

    public getTagObjs() {
        return this.getTemplateViewModel().tagObjs();
    }

    public getOrderBy() {
        return this.getTemplateViewModel().orderBy;
    }

    public getOrderByDirection() {
        return this.getTemplateViewModel().orderByDirection;
    }

    public setShowType(showType): void {
        this.getTemplateViewModel().showType(showType);
    }

    public getShowType() {
        return this.getTemplateViewModel().showType();
    }

    public setIsShowTagSuggestions(isShowTagSuggestions): void {
        this.getTemplateViewModel().isShowTagSuggestions(isShowTagSuggestions);
    }

    public getIsShowTagSuggestions() {
        return this.getTemplateViewModel().isShowTagSuggestions();
    }

    public setIsGlobalLockEnabled(isGlobalLockEnabled): void {
        this.getTemplateViewModel().isGlobalLockEnabled(isGlobalLockEnabled);
    }

    public getIsGlobalLockEnabled() {
        return this.getTemplateViewModel().isGlobalLockEnabled();
    }
    public getIdTag() {
        return this.getTemplateViewModel().idTag();
    }

    public getTag() {
        return this.getTemplateViewModel().tag();
    }

    private appendTagToSelection(tag): void {
        let tagObjs = this.getTagObjs();
        let filtered = tagObjs.filter((t) => t.id == tag.id);
        if (filtered.length == 0) {

            tagObjs.push(tag);
            this.addHtmlTag(tag);
            this.setTagObjs(tagObjs);
        }
    }

    private replaceTagInSelection(tag): void {
        this.setTagObjs([]);
        this.setTagObjs([tag]);
    }

    public removeTagFromSelection(tagId): void {
        let tags = this.getTagObjs().filter((t) => t.id != tagId);
        this.setTagObjs(tags);
    }

    public getTagsForRequest() {
        return this.getTagObjs().map((t) => {
           return {id: t.id, name: t.name};
        });
    }

    public asMultipleSelectionMode(): void {
        this.setSelectionMode(filterTag_template.MULTIPLE_SELECTION_MODE);
    }

    public isMultipleSelectionMode(): boolean {
        return this.isSelectionMode(filterTag_template.MULTIPLE_SELECTION_MODE);
    }

    public isSingleSelectionMode(): boolean {
        return this.isSelectionMode(filterTag_template.SINGLE_SELECTION_MODE);
    }

    public isSelectionMode(selectionMode: string): boolean {
        return (this.getSelectionMode() == selectionMode);
    }

    protected onChangeFilterAction(data): void {

        this.caller.filterSimpleOnChange(this.idElement);
    }

    protected onChangeInput(data, event) {
        clearTimeout(this.debounceTimerId);
        let self = this;
        this.debounceTimerId = window.setTimeout(function () {
            let input = event.target;
            let inputWrapper = input.parentNode;
            let closeBtn = inputWrapper.querySelector('#tag-input-close');
            // if (!closeBtn.classList.contains('is-showing')) {
            //     closeBtn.classList.add('is-showing');
            // }
            self.onChangeTagDataListTag(event, self.viewModel[self.idElement].idTag);
        }, this.delay);
    }

    protected onChangeTagDataListTag(event, idTag) {
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById("tags").childNodes;
        if (inputVal.length >= 2) {
            this.caller.getTagsSuggestion(inputVal, this.idElement);
            this.setIsShowTagSuggestions(true);
            this.getTemplateViewModel().optionsLoading(true);

        }
        for (let op of options) {
            if (op.value === inputVal) {
                idTag(op.id);
                input.blur();
                this.caller.filterSimpleOnChange(this.idElement);
                break;
            }
        }
    }

    public setIsDisabled(isDisabled: boolean) {
        this.getTemplateViewModel().isDisabled(isDisabled);
    }

    protected onClearInput(event) {
        let button = event.target;
        // if (button.classList.contains('is-showing')) {
            // button.classList.remove('is-showing');
            this.viewModel[this.idElement].idTag(null);
            this.viewModel[this.idElement].tag("");
            this.viewModel[this.idElement].tags([]);
            this.viewModel[this.idElement].tagObj(null);
            this.viewModel[this.idElement].isShowTagSuggestions(false);
            if (this.isSingleSelectionMode()) {
                this.setTagObjs([]);
            }
            this.caller.filterSimpleOnChange(this.idElement);

        // }
    }

    public clearInput() {
        const tagFilterElement = document.querySelector(`#${this.idElement}`) as HTMLElement;
        if (tagFilterElement) {
            let button = tagFilterElement.querySelector("#tag-input-close");
            // if (button && button.classList.contains('is-showing')) {
                // button.classList.remove('is-showing');
                this.viewModel[this.idElement].idTag(null);
                this.viewModel[this.idElement].tag("");
                this.viewModel[this.idElement].tags([]);
                this.viewModel[this.idElement].tagObj("");
                this.viewModel[this.idElement].isShowTagSuggestions(false);
                //this.caller.filterSimpleOnChange(this.idElement);
            // }
        }
    }

    /** Clear the search field only; keeps the current single-selection tag in tagObjs. */
    public clearSearchInputOnly(): void {
        this.getTemplateViewModel().tag_value("");
        this.getTemplateViewModel().showXButton(false);
        this.setTags([]);
        this.setIsShowTagSuggestions(false);
    }


    protected onBlurTag(data, event) {

        this.setTag(data);
        this.handleSelectionModeSpecific(data);
        this.setTags([]);
        this.setIsShowTagSuggestions(false);
        this.caller.filterSimpleOnChange(this.idElement);
    }

    private handleSelectionModeSpecific(data): void {

        if (this.isMultipleSelectionMode()) {
            if (this.getTagObjs().length == 0) {
                this.addCaption();
            }
            this.appendTagToSelection(data);
            this.clearInput();
        } else {
            this.replaceTagInSelection(data);
        }
    }

    public toggleCloseButton(): void {

        let closeBtn = document.getElementById('tag-input-close');
        let idTag = this.getIdTag();

        // if (idTag == null) {
        //     closeBtn.classList.remove('is-showing');
        // } else {
        //     closeBtn.classList.add('is-showing');
        // }
    }

    public setSelectedTagsFromRequestParams(tags): void {

        if (this.isSingleSelectionMode()) {
            if (tags.length > 0) {
                this.setTagObjs([tags[0]]);
                this.setTagObj(tags[0]);
                this.setIdTag(tags[0].id);
            } else {
                this.setTagObjs([]);
                this.setTagObj(null);
                this.setIdTag(null);
            }
            this.clearSearchInputOnly();
            return;
        }

        this.resetTagContainer();

        if (tags.length > 0) {
            this.addCaption();
        }
        for (const tag of tags) {
            this.appendTagToSelection(tag);
        }
    }

    public setPlaceholderText(text: string): void {
        this.getTemplateViewModel().placeholderText(text);
    }

    public setIconClass(iconClass: string): void {
        this.getTemplateViewModel().iconClass(iconClass);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/filterTag_template.ts